module.exports = __webpack_public_path__ + "static/media/item_selected.753216c1.svg";